import { authApiService as n, userApiService as e, subscriptionPlanApiService as o } from "@waitroom/common-api";
import { CACHE_KEY_SUBSCRIPTION_PLANS as a } from "../cache/keys.es.js";
import { inactiveOptions as u } from "../options.es.js";
const h = ({
  userId: t,
  accessToken: r,
  params: i
}) => ({
  mutationFn: () => {
    if (!t || !r) throw new Error("Unauthorized");
    return e.activateTrial(t, {
      ...i,
      data: { token: r }
    });
  }
}), l = ({
  accessToken: t,
  params: r
}) => ({
  mutationFn: () => n.hostOptIn({
    data: { accessToken: t },
    ...r
  })
}), p = () => [a], v = () => ({
  queryKey: p(),
  queryFn: o.getPlans,
  ...u["1h"]
});
export {
  h as activateTrialMutation,
  v as getPlansQuery,
  p as getPlansQueryKey,
  l as hostOptInMutation
};
